// 绩效考核
<template>
  <basicContainer>
    <div class="announcementManage">
      <el-card>
        <ul class="khgz">
          <li>
            <strong>1、绩效考核总分数：</strong>由主管对直属员工的本月重点任务进行评价，包括三个指标（完成结果50%，团队配合30%，积极性20%）；最后取当月所有重点任务评分的平均值为绩效评价总分。
          </li>
          <li>
            <strong>2、评分等级：</strong>
            <dl>
              <dd><span>3.0</span>：(差)没有胜任力；</dd>
              <dd><span>3.25</span>：(中)以结果为导向，属于基本完成任务；</dd>
              <dd><span>3.5</span>：(良)以结果为导向，保质保量保工时完成任务并主动协同任务各方；</dd>
              <dd><span>3.75</span>：(优秀)能自驱主动要任务并保质保量保工时完成任务并协同任务各方；</dd>
              <dd><span>4.0</span>：(超预期)除了优秀完成任务外，给公司带来额外重要收益；</dd>
            </dl>
          </li>
          <li>
            <strong>3、工资计算比例：</strong>4.0为绩效工资的150%、3.75为120%、3.5为100%、3.25为50%、3.0为0%
          </li>
        </ul>
        <div class="workflowIMG"><img src="/workflow/workflow.png"></div>
      </el-card>
      <div style="margin-top:30px">
        <avue-crud ref="avueCrud" :data="tableData" :option="option" v-model="form" :table-loading="TABLE_LOADING"
          :page.sync="TABLE_PAGE" @search-change="SEARCH_CHANGE" @refresh-change="TABLE_REFRESH"
          @search-reset="SEARCH_RESET" @cell-click="CELL_CLICK" @selection-change="SELECTION_CHANGE"
          @sort-change="SORT_CHANGE" @size-change="SIZE_CHANGE" @current-change="CURRENT_CHANGE"
          :before-open="beforeOpen" :before-close="beforeClose" @row-update="rowUpdate" @row-save="rowSave"
          @row-del="rowDel" :search.sync="search">
          <template v-slot:menuLeft>
            <el-button type="primary" size="small" @click="exportExcel()">导出</el-button>
          </template>
          <template v-slot:menu="{type,size,row,index}">
            <el-button size="small" type="text" icon="el-icon-view" @click.stop="viewPage(row, index)">查看</el-button>
          </template>
        </avue-crud>
      </div>
    </div>
    <el-dialog title="查看" :visible.sync="khxqConfig.dialogVisible" top="10vh" width="80%" append-to-body
      v-if="khxqConfig.dialogVisible" v-dialogDrag :close-on-click-modal="false">
      <!-- <khxq :khxqConfig="khxqConfig"></khxq> -->
      <div class="iframeMain">
        <iframe :src="queryDataUrl" frameborder="0" height="100%" width="100%"></iframe>
      </div>
    </el-dialog>
    <!-- 导出 -->
    <el-dialog title="导出数据" :visible.sync="downloadData.dialogVisible" width="30%" :modal-append-to-body="false">
      <el-row>
        <el-form :inline="true" ref="downloadView" :model="downloadData.form" label-suffix=":">
          <el-col :span="24">
            <el-form-item label="文件名称" prop="fileName" :rules="[{ 'required': true, 'message': '请输入文件名' }]"
              :required="true">
              <el-input v-model="downloadData.form.fileName">
                <template slot="append">.xlsx</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downloadData.dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="todownloadData" :loading="downloadData.btnflag">确 定</el-button>
      </span>
    </el-dialog>
  </basicContainer>
</template>

<script>
import { dateFormat } from '@/framework/util/date.js'
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'
// import khxq from './khxqNew'
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}
export default {
  // components: { khxq },
  mixins: [crudPageMinix],
  data() {
    return {
      search: [],
      queryDataUrl: '',
      downloadData: {
        dialogVisible: false,
        form: {
          fileName: '员工绩效_' + new Date().Format('yyyy-MM-dd')
        },
        btnflag: false
      },
      yf: '',
      option: {
        stripe: true,
        border: true,
        page: true,
        selection: true,
        tip: false,
        align: 'center',
        menuAlign: 'center',
        searchMenuSpan: 6,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 170,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: true,
        menuWidth: 150,
        emptyBtn: false,
        column: [
          {
            label: '月份',
            prop: 'yf',
            search: true,
            hide: true,
            type: 'month',
            format: 'yyyy-MM',
            valueFormat: 'yyyy-MM',
            // searchSpan: 5,
            searchValue: dateFormat(new Date(), 'yyyy-MM'),
            change: ({ value }) => {
              this.yf = value
              setTimeout(() => {
                this.loadData()
              }, 0)
            }
          },
          {
            label: '员工姓名',
            prop: 'ygxm',
            minWidth: 120,
            search: true,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入开始时间',
                trigger: 'blur'
              }
            ]
            // searchSpan: 6,
          },
          {
            label: '部门',
            prop: 'orgIdList',
            search: true,
            hide: true,
            type: 'select',
            dicData: [],
            props: {
              label: 'name',
              value: 'id'
            }
          },
          {
            label: '一级部门',
            prop: 'yjbm',
            // search: true,
            hide: true,
            // searchLabelWidth: 75,
            type: 'select',
            // searchSpan: 6,
            props: {
              label: 'name',
              value: 'id'
            },
            change: ({ value }) => {
              if (this.$refs.avueCrud && this.$refs.avueCrud.searchForm) {
                this.$set(this.$refs.avueCrud.searchForm, 'ejbm', '')
              }
              if (value) {
                this.getYjbm('ejbm', value)
              } else {
                if (this.$refs.avueCrud && this.$refs.avueCrud.DIC) {
                  this.$set(this.$refs.avueCrud.DIC, 'ejbm', [])
                }
                this.$set(
                  this.option.column[
                  this.findArray(this.option.column, 'ejbm', 'prop')
                  ],
                  'dicData',
                  []
                )
              }
            }
          },
          {
            label: '二级部门',
            prop: 'ejbm',
            // searchLabelWidth: 75,
            // search: true,
            hide: true,
            type: 'select',
            // searchSpan: 6,
            dicData: [],
            props: {
              label: 'name',
              value: 'id'
            }
          },
          {
            label: '姓名',
            prop: 'xm',
            minWidth: 140
          },
          // {
          //   label: '工号',
          //   prop: 'id',
          //   minWidth: 100
          // },
          {
            label: '账号',
            prop: 'zh',
            hide: true
          },
          {
            label: '直属主管',
            prop: 'zszg',
            search: true,
            minWidth: 120
          },
          // {
          //   label: '任务评分',
          //   prop: 'rwpf',
          //   minWidth: 100
          // },
          {
            label: '任务数',
            prop: 'byrws',
            minWidth: 100
          },
          {
            label: '主管评分',
            prop: 'zgpf',
            minWidth: 100
          }
          // {
          //   label: 'HR评分',
          //   prop: 'hrpf',
          //   minWidth: 100
          // },
          // {
          //   label: '总分',
          //   prop: 'hsf',
          //   minWidth: 100
          // }
        ]
      },
      form: {},
      tableData: [],
      khxqConfig: {
        dialogVisible: false,
        gh: '',
        yf: '',
        rwpf: '',
        zgpf: '',
        hrpf: ''
      },
      // ids: [],
      SELECT_LIST: [],
      exportData: []
    }
  },

  mounted() {
    this.loadData()
    this.getYjbm('yjbm', '1')
    this.$http.post('/fighter-uaap-manage/org/list', {
      entity: {
        parentPermissionSubjectId: 1
      }
    }).then(response => {
      console.log(response)
      this.$set(this.option.column[this.findArray(this.option.column, 'orgIdList', 'prop')], 'dicData', response.data)
    })
  },
  methods: {
    exportExcel() {
      if (this.SELECT_LIST.length == 0) {
        let yf = this.yf || this.option.column[this.findArray(this.option.column, 'yf', 'prop')].searchValue
        this.$http.post('/StaffPerformance/queryNew', { yf },
          {
            params: {
              pageNum: 1,
              pageSize: this.TABLE_PAGE.total
            }
          })
          .then((response) => {
            console.log(response.data.records)
            this.exportData = response.data.records
            this.downloadData.dialogVisible = true
          })
          .catch((error) => {
            this.$message.error(error.msg || error.message)
          })
      } else {
        this.exportData = this.SELECT_LIST
        // console.log(this.exportData)
        this.downloadData.dialogVisible = true
      }
    },
    // 确定导出文件
    todownloadData() {
      this.btnflag = true
      this.$message.info('正在下载...')
      let params = {
        fileName: this.downloadData.form.fileName + '.xlsx',
        doDownload: true
      }
      let arrdata = this.exportData
      this.$downloadFile.post('/staff/dataExport', arrdata, {
        params
      }).then(res => {
        this.$message.success('下载成功!')
        this.downloadData.btnflag = false
        this.downloadData.dialogVisible = false
      }).catch(error => {
        this.downloadData.btnflag = false
        this.$message.error(error.msg)
      })
    },
    getYjbm(name, value) {
      this.$http.post('/org/list', {
        entity: {
          parentPermissionSubjectId: value,
          status: '1'
        }
      }, {
        params: {
          downwardRecursive: false
        }
      }).then(res => {
        this.$set(
          this.option.column[
          this.findArray(this.option.column, name, 'prop')
          ],
          'dicData',
          res.data
        )
      })
    },
    loadData(
      TABLE_PAGE = this.TABLE_PAGE,
      QUERY_CONDITIONS = this.QUERY_CONDITIONS,
      TABLE_ORDER = this.TABLE_ORDER,
      done
    ) {
      this.TABLE_LOADING = true // 表格转圈
      this.QUERY_CONDITIONS.orgIdList = [this.search.orgIdList] || []
      this.QUERY_CONDITIONS.yf = this.yf || this.option.column[this.findArray(this.option.column, 'yf', 'prop')].searchValue
      this.$http.post('/StaffPerformance/queryNew', QUERY_CONDITIONS, {
        params: {
          pageNum: TABLE_PAGE.currentPage,
          pageSize: TABLE_PAGE.pageSize
        }
      })
        .then((response) => {
          this.RELOAD_CRUD(response.data.records)
          this.TABLE_PAGE.total = response.data.total || response.data.records.length
          this.SELECT_LIST = []
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
        .finally(() => {
          this.TABLE_LOADING = false // 表格转圈
          typeof done === 'function' && done()
        })
    },
    viewPage(row, index) {
      this.$http.post('/StaffPerformance/queryDetailsUrl', null, {
        params: {
          Monthy: this.yf || this.option.column[this.findArray(this.option.column, 'yf', 'prop')].searchValue,
          loginName: row.zh
        }
      }).then(response => {
        if (response.data != null) {
          this.queryDataUrl = response.data.url + '&' + 'showNav' + '=' + 'no' + '&' + 'isIframe' + '=' + 'true' + '&' + 'isHiddenBtn' + '=' + 1
          this.khxqConfig.dialogVisible = true
        } else {
          if (row.byrws != '待填写') {
            this.$http.post('/StaffPerformance/getYbxx', null, {
              params: {
                Monthy: this.yf || this.option.column[this.findArray(this.option.column, 'yf', 'prop')].searchValue,
                gh: row.zh
              }
            }).then(response => {
              let data = response.data
              if (data.length > 0) {
                this.queryDataUrl = '/#/applyForm?businessKey=' + data[0].id + '&formId=4569e701862e4f93b859099ca950623c&pageKey=VIEW' + '&' + 'showNav' + '=' + 'no' + '&' + 'isIframe' + '=' + 'true' + '&' + 'isHiddenBtn' + '=' + 1
                this.khxqConfig.dialogVisible = true
              } else {
                this.$message.warning('绩效未填写或待评价！请稍后再试！')
              }
            })
          } else {
            this.$message.warning('绩效未填写！请稍后再试！')
          }
        }
      })
      // this.khxqConfig.dialogVisible = true
      // this.khxqConfig.gh = row.zh
      // this.khxqConfig.xm = row.xm
      // this.khxqConfig.yf = this.yf || this.option.column[this.findArray(this.option.column, 'yf', 'prop')].searchValue
    },
    SELECTION_CHANGE(selection = [], e) {
      this.SELECT_LIST = selection
    }
  }
}
</script>
<style lang="scss" scoped>
.iframeMain {
  height: 70vh;
  width: 100%;
}

.khgz {
  list-style: none;
  padding-left: 0;
  font-size: 12px;
  line-height: 2;

  & dl {
    display: inline-grid;

    & dd {
      & span {
        width: 24px;
        display: inline-block;
      }

      li {
        float: left;
        display: contents;
        padding-left: 50px;
      }
    }
  }
}

.el-card {
  border-left: 5px solid #5a9bf5 !important;
}

.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
}

:deep(.theme-longyun .avue-contail, .theme-longyun .avue-main) {
  background-color: white !important;
}

.workflowIMG {
  display: inline-block;
  width: 60%;

  img {
    max-width: 100%;
  }
}
</style>
